import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import ErrorContainer from '../portal/errorContainer';
import { TextButton } from '@checkmarx/cx-ui';
const queryString = require("query-string");

@inject('translationsStore') @observer
export default class ExternalLoginError extends Component {

    constructor(props) {
        super(props);

        const result = queryString.parse(window.location.hash);
        this.errorMessege = ExternalLoginError.sanitizeUrl(result['errormessage']);

        if(!this.errorMessege)
        {
            this.errorMessege = result['/externalloginerror?errormessage'];
        }
    }

    static sanitizeUrl(url){
        const regex = /[<>[\](){}]/g;
        return regex.test(url) ? '' : url;
    }
    
    render(){
        
        const customStyle = {
            fontWeight: 'normal',
            fontSize: 'inherit',
            textDecoration: 'underline',
            marginRight: '5px'
        };
        
        const message = this.returnUrl &&
            <div>
                {this.props.translationsStore.translate('CLICK')}
                <TextButton
                    text={this.props.translationsStore.translate('HERE')}
                    onClick={this.goBack}
                    style={customStyle}
                />
                {this.props.translationsStore.translate('EXTERNAL_LOGIN_ERROR_MESSAGE_AFTER_LINK')}
            </div>;
        
        return (
        
            <ErrorContainer
                    error={this.errorMessege || this.props.translationsStore.translate('USER_AUTHENTICATION_FAILED')}
                    errorDescription={message}>
            </ErrorContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/externalLoginError.jsx